import { Children, useEffect, useLayoutEffect } from 'react';
/**
 * client-only component
 */
export const HeadSideEffect = (props) => {
    const { headManager, reduceComponentsToState } = props;
    function emitChange() {
        if (headManager && headManager.mountedInstances) {
            const headElements = Children.toArray(Array.from(headManager.mountedInstances).filter(Boolean));
            headManager.updateHead(reduceComponentsToState(headElements, props));
        }
    }
    useLayoutEffect(() => {
        headManager?.mountedInstances?.add(props.children);
        return () => {
            headManager?.mountedInstances?.delete(props.children);
        };
    });
    // We need to call `updateHead` method whenever the `SideEffect` is trigger in all
    // life-cycles: mount, update, unmount. However, if there are multiple `SideEffect`s
    // being rendered, we only trigger the method from the last one.
    // This is ensured by keeping the last unflushed `updateHead` in the `_pendingUpdate`
    // singleton in the layout effect pass, and actually trigger it in the effect pass.
    useLayoutEffect(() => {
        if (headManager) {
            headManager._pendingUpdate = emitChange;
        }
        return () => {
            if (headManager) {
                headManager._pendingUpdate = emitChange;
            }
        };
    });
    useEffect(() => {
        if (headManager && headManager._pendingUpdate) {
            headManager._pendingUpdate();
            headManager._pendingUpdate = null;
        }
        return () => {
            if (headManager && headManager._pendingUpdate) {
                headManager._pendingUpdate();
                headManager._pendingUpdate = null;
            }
        };
    });
    return null;
};
